import WordSeparator from './Root.vue';
import WordSeparatorPage from './views/WordSeparatorPage.vue';

export default {
  path: 'separador/palavras',
  name: 'admin-word-separator',
  component: WordSeparator,
  redirect: '/novo',
  children: [
    {
      path: 'novo',
      name: 'admin-word-separator-new',
      component: WordSeparatorPage,
    },
  ],
};
